export default (container, value) => {
    var returnValue = false;
    var pos = container.indexOf(value);
    if (pos >= 0) {
        returnValue = true;
    }
    return returnValue;
}



// WEBPACK FOOTER //
// ./scripts/util/includes.js